import { useTranslation } from "react-i18next"
import { useRef } from "react"
import SidebarGroup from "../sidebarGroup"
import useStorages from "hooks/useStorages"
import useLayout from "hooks/useLayout"
import SidebarRow from "../SidebarRow"
import { ReactComponent as AddIcon } from "assets/icons/add.svg"
import { ReactComponent as RemoveIcon } from "assets/icons/remove.svg"
import { ReactComponent as AdjustIcon } from "assets/icons/equal.svg";
import useAccess from "@/hooks/useAccess"
import { AccessRole } from "@/types"

interface RightSidebarProps {
    className?: string;
    children?: React.ReactNode;
    storageId?: string;
}

const RightSidebar: React.FC<RightSidebarProps> = ({ className, children, storageId }) => {

    const {
        openDialog,
    } = useLayout()

    const {
        storage,
        storages
    } = useStorages({ storageId })

    const currentStorage = storageId ? storage : storages.find(s => s.id === storageId)
    const requireActionsLinkedToTransactions = currentStorage?.settings?.requireActionsLinkedToTransactions === true
    const stockAdjustmentEnabled = currentStorage?.settings?.enableStockAdjustment !== false

    const {
        limitToRoles
    } = useAccess({ storageId: storageId || '' })

    // Translation.
    const { t } = useTranslation();
    const sidebarRef = useRef<HTMLDivElement>(null);

    // Define Tailwind classes as constants
    const sidebarClasses = `fixed top-0 lg:top-16 bottom-0 right-0 overflow-y-auto invisible lg:visible lg:w-60 !m-0 ${className ? className : ''}`;

    // Return the sidebar component.
    return <div className={sidebarClasses}>
        <div ref={sidebarRef} className={`relative min-h-full`}>
            {storageId && currentStorage && limitToRoles([AccessRole.OWNER, AccessRole.EDITOR, AccessRole.WORKER]) &&
                <>
                    {requireActionsLinkedToTransactions ? (
                        <SidebarGroup title={t('titleCreateTransaction')} allwaysOpen={true}>
                            <SidebarRow text={t('buttonNewIncoming')} icon={<AddIcon />} to={`/storage/transactions/create/incoming`} style={`border`} />
                            <SidebarRow text={t('buttonNewOutgoing')} icon={<RemoveIcon />} to={`/storage/transactions/create/outgoing`} style={`border`} />
                            {stockAdjustmentEnabled && (
                                <SidebarRow text={t(`buttonAdjust`)} icon={<AdjustIcon />} onClick={() => openDialog(`adjust_product_stock`)} style={`border`} />
                            )}
                        </SidebarGroup>
                    ) : (
                        <SidebarGroup title={t('menuStockActions')} allwaysOpen={true}>
                            <SidebarRow text={t(`buttonAdd`)} icon={<AddIcon />} onClick={() => openDialog(`add_to_stock`)} style={`border`} />
                            <SidebarRow text={t(`buttonRemove`)} icon={<RemoveIcon />} onClick={() => openDialog(`remove_from_stock`)} style={`border`} />
                            {stockAdjustmentEnabled && (
                                <SidebarRow text={t(`buttonAdjust`)} icon={<AdjustIcon />} onClick={() => openDialog(`adjust_product_stock`)} style={`border`} />
                            )}
                        </SidebarGroup>
                    )}
                </>
            }
            {children}
        </div>
    </div>
}

export default RightSidebar

